import script from "./part3.vue?vue&type=script&setup=true&lang=js"
export * from "./part3.vue?vue&type=script&setup=true&lang=js"

import "./part3.vue?vue&type=style&index=0&id=2e848de2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "D:\\办公\\projects\\drl-live\\drl-live-jk\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e848de2"]])

export default __exports__